import React, { useCallback } from "react";
import { moneyFormatter } from "../../utils/MoneyUtils";
import { withTranslation } from "react-i18next";
import BetItem from "./BetItem";
import { currencyCode } from "../../constants/general";
import { useLotto5d } from "../../store/lotto5d/Lotto5dContext";

function BetCard() {
    const {
        totalBalance,
        classes,
        isBetting = false,
        currentBetting: {postGroup},
        onEditPost,
        summaryAmount,
        t,
        onDeleteItem,
        onClearItem,
        setFilter
    } = useLotto5d();

    // Handle edit item
    const onEditItem = useCallback(() => {
        if (!isBetting) {
            setFilter(prev => ({ isShow: !prev.isShow }));
        }
    }, [isBetting, setFilter]);

    // Calculate total balance during betting
    let computedBalance = totalBalance;
    let containerClass = classes ?? "w-bet-item-v1";

    if (isBetting) {
        computedBalance = 0;
        postGroup.forEach(p => {
            computedBalance += p.summaryAmount.betAmount;
        });
    }

    return (
        <div className={containerClass}>
            <div className={`bg-white rounded ${containerClass}`}>
                {postGroup?.map((item, index) => (
                    <div key={index} className="w-bet-item">
                        {item.posts !== "RANGE" && (
                            <div
                                onClick={() =>
                                    onEditPost({ index: index, postGroup: item })
                                }
                                className="font-weight-bold text-info text-left pl-1"
                            >
                                {item?.posts
                                    ?.replaceAll("LoABCD", "Lo")
                                    ?.replaceAll("ABCDlo", "Lo")}
                            </div>
                        )}

                        <div className="pl-1">
                            <BetItem
                                onDeleteItem={onDeleteItem}
                                onClearItem={onClearItem}
                                item={item}
                                t={t}
                            />
                        </div>

                        <div className="border-total mb-1" />

                        <div className="row font-weight-bold bg-green">
                            <div className="w-left-side row text-white">
                                <div>សរុប</div>&nbsp;:&nbsp;
                                <div>
                                    {moneyFormatter(
                                        item.summaryAmount?.betAmount,
                                        currencyCode(),
                                        "text-white py-2"
                                    )}
                                </div>
                            </div>

                            {item.summaryAmount?.winAmount > 0 && (
                                <div className="w-left-side row text-white">
                                    <div>{t("labels:ticket.total_win")}</div>&nbsp;:&nbsp;
                                    <div>
                                        {moneyFormatter(
                                            item.summaryAmount?.winAmount,
                                            currencyCode(),
                                            "text-white py-2"
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>

            {/* Total when betting multiple items */}
            {isBetting && postGroup.length > 1 && computedBalance > 0 && (
                <div className="row p-0 m-0 font-weight-bold bg-total text-white">
                    <div className="w-left-side row p-0 m-0">
                        <div className="w-total text-black">សរុប</div>&nbsp;:&nbsp;
                        <div>{moneyFormatter(computedBalance, currencyCode())}</div>
                    </div>
                </div>
            )}

            {/* Summary block when not betting */}
            {!isBetting && postGroup.length > 1 && (
                <div
                    onClick={onEditItem}
                    className="w-bet-item-v1 bg-total text-white rounded"
                >
                    {summaryAmount?.betAmount > 0 && (
                        <div className="row p-0 m-0 font-weight-bold">
                            <div className="w-left-side row p-0 m-0 bg-green">
                                <div className="w-total text-white">សរុបរួម</div>&nbsp;:&nbsp;
                                <div>
                                    {moneyFormatter(
                                        summaryAmount?.betAmount ?? 0,
                                        currencyCode(),
                                        "text-white"
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="bg-danger rounded">
                        {summaryAmount?.winAmount > 0 && (
                            <div className="row p-0 m-0 font-weight-bold">
                                <div className="w-left-side row p-0 m-0">
                                    <div className="w-total text-black">រង្វាន់</div>&nbsp;:&nbsp;
                                    <div>
                                        {moneyFormatter(
                                            summaryAmount?.winAmount ?? 0,
                                            currencyCode()
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default withTranslation()(BetCard);
